import {
  AUTH_CHANNEL,
  LOGIN_EVENT,
  LOGOUT_EVENT,
} from "@workspace/auth/broadcast";
import { Logout as handleLogout } from "@workspace/auth/client";
import { getSession } from "@workspace/auth/session";

const STORAGE_KEY = "token";

const setToken = (jwt) => {
  try {
    localStorage.setItem(STORAGE_KEY, jwt);
  } catch (error) {
    console.error("Error setting token:", error);
  }
};

const removeToken = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Error removing token:", error);
  }
};

const syncTokenFromSession = async () => {
  const session = await getSession({ credentials: "include" });
  const jwt = session?.user?.jwt;
  if (jwt) {
    setToken(jwt);
  } else {
    removeToken();
  }
};

export const fetchSharedToken = async () => {
  try {
    await syncTokenFromSession();

    const channel = new BroadcastChannel(AUTH_CHANNEL);

    channel.onmessage = async (event) => {
      if (event.data === LOGOUT_EVENT) {
        removeToken();
        window.location.reload();
      } else if (event.data === LOGIN_EVENT) {
        await syncTokenFromSession();
        window.location.reload();
      }
    };
  } catch (error) {
    console.error("Error in fetching shared token:", error);
  }
};

export const Logout = async () => {
  try {
    await handleLogout();
    removeToken();
  } catch (error) {
    console.error("Error in logging out:", error);
  } finally {
    window.location.reload();
  }
};
